import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box } from '@mui/material';
import { BannerContainer } from './BannerContainer';
import { BannerPlaceholder } from './BannerPlaceholder';
import { Banner } from '../../../interfaces/Banner/Banner';
import { getBanners } from '../../../api/Banner';

export const Banners = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getBanners({ page: 0, pageSize: 1000 })
      .then((b) => setBanners(b.data))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%' }}
    >
      {loading && <BannerPlaceholder />}

      {banners.map((banner) => (
        <BannerContainer key={banner.id} banner={banner} />
      ))}
    </Box>
  );
};
